/** レクチャー画面を表示する. */
export const OPEN_POPUP_LECTURE = "OPEN_POPUP_LECTURE";
/** レクチャー画面を閉じる. */
export const CLOSE_POPUP_LECTURE = "CLOSE_POPUP_LECTURE";
/** 初回ログインフラグ. */
export const UPDATE_FIRST_LOGIN = "UPDATE_FIRST_LOGIN";
